import { render } from "./base.vue?vue&type=template&id=7b547fb4&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"

import "./base.vue?vue&type=style&index=0&id=7b547fb4&lang=css"
import "./base.vue?vue&type=style&index=1&id=7b547fb4&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b547fb4"]])

export default __exports__